import DOMPurify from 'dompurify';
import React, { useMemo, useState, useEffect } from 'react';

interface IProps {
  dangerousHtml: string;
  renderer?: {
    [selector: string]: (element: Element, index: number, numberOfItems: number) => void;
  };
}

export function UserHtml(props: IProps) {
  const ref = React.useRef<HTMLDivElement | null>(null); //React.createRef<HTMLDivElement>();// as React.RefObject<HTMLDivElement>;

  const { dangerousHtml } = props;

  const clean = useMemo(() => {
    setTimeout(() => setIsDirty(true), 1);
    return DOMPurify.sanitize(dangerousHtml);
  }, [dangerousHtml]);

  const [isDirty, setIsDirty] = useState(true);

  // Use initially provided callbacks to avoid re-rendering every time the parent is updated.
  const [renderer] = useState(props.renderer);

  useEffect(() => {
    if (!ref.current) {
      return;
    }

    if (!isDirty) {
      return;
    }

    setIsDirty(false);

    const links = ref.current.querySelectorAll('a');
    for (const link of links) {
      if (link.target !== '_top' && link.target !== '_blank') {
        link.target = '_top';
      }
    }

    if (renderer) {
      Object.entries(renderer).forEach(([selector, clb]) => {
        const items = Array.from(ref.current!.querySelectorAll(selector));
        items.forEach((item, index) => clb(item, index, items.length));
      });
    }
  }, [ref.current, renderer, isDirty]);

  const output = useMemo(() => <div className="user-html" ref={ref} dangerouslySetInnerHTML={{ __html: clean }} />, [clean]);

  return output;
}
